import { FC } from 'react'

import { Box, Flex, IconButton, Text } from '@chakra-ui/react'

import { SuccessModalProps } from '@core/components/FeedbackModal/SuccessModal/types'
import { MainButton } from '@core/components/MainButton'
import { CustomModal } from '@core/components/Modal/Modal'

import { IconClose, IconDeleteCircle } from '@page/absence/assets/icons'

export const SuccessModal: FC<SuccessModalProps> = ({ isOpen, onClose }) => {
    return (
        <CustomModal
            size={'md'}
            removeBorders
            isOpen={isOpen}
            onClose={close}
            isHeaderVisible={false}
            body={
                <Box p={'20px'}>
                    <Flex w={'full'} alignItems={'center'} justifyContent={'space-between'} mb={'16px'}>
                        <Flex
                            justifyContent={'center'}
                            alignItems={'center'}
                            bg={'#E9EFFE'}
                            borderRadius={'full'}
                            w={'44px'}
                            h={'44px'}
                        >
                            <IconDeleteCircle color={'#245AF0'} />
                        </Flex>
                        <IconButton
                            variant={'ghost'}
                            icon={<IconClose w={'16px'} h={'16px'} color={'#4B4B4E'} />}
                            aria-label={'close'}
                            onClick={onClose}
                        />
                    </Flex>
                    <Text fontSize={'16px'} fontWeight={'semibold'} color={'#0C0C0D'} mb={'8px'}>
                        Thanks!
                    </Text>
                    <Text fontSize={'13px'} fontWeight={'medium'} color={'#4B4B4E'} mb={'8px'}>
                        We appreciate your feedback, it helps us improve our product and provide better services.
                    </Text>
                    <Flex justifyContent={'flex-end'} alignItems={'center'}>
                        <MainButton size={'sm'} title={'Close'} view={'primary'} onClick={onClose} />
                    </Flex>
                </Box>
            }
        />
    )
}
